import { render, staticRenderFns } from "./UiHallFilter.vue?vue&type=template&id=38555a26&lang=pug&"
import script from "./UiHallFilter.vue?vue&type=script&lang=js&"
export * from "./UiHallFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports